import { css, keyframes } from 'styled-components';
export const animationKeys = [
    'in',
    'out',
    'duration',
    'animation',
    'isDisplayed',
    'animateInitialRender',
    'animationName',
    'animationDuration',
];
export const defaultAnimationDuration = 250;
// naming is based on https://animate.style/
const fadeIn = keyframes `
  from { opacity: 0; }
  to { opacity: 1; }
`;
const fadeInRight = keyframes `
  from { opacity: 0; transform: translateX(30px); }
  to { opacity: 1; transform: translateX(0px); }
`;
const fadeInDown = keyframes `
  from { opacity: 0; transform: translateY(-30px); }
  to { opacity: 1; transform: translateY(0px); }
`;
const fadeInLeft = keyframes `
  from { opacity: 0; transform: translateX(-30px); }
  to { opacity: 1; transform: translateX(0px); }
`;
const fadeInTop = keyframes `
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0px); }
`;
const slideInRight = keyframes `
  from { transform: translateX(100%); }
  to { transform: translateX(0px); }
`;
const zoomIn = keyframes `
  from { opacity: 0; transform: scale(1.05); }
  to { opacity: 1; transform: scale(1); }
`;
const fadeOut = keyframes `
  from { opacity: 1; }
  to { opacity: 0; }
`;
const fadeOutRight = keyframes `
  from { opacity: 1; transform: translateX(0px); }
  to { opacity: 0; transform: translateX(30px); }
`;
const fadeOutDown = keyframes `
  from { opacity: 1; transform: translateY(0px); }
  to { opacity: 0; transform: translateY(30px); }
`;
const fadeOutLeft = keyframes `
  from { opacity: 1; transform: translateX(0px); }
  to { opacity: 0; transform: translateX(-30px); }
`;
const fadeOutTop = keyframes `
  from { opacity: 1; transform: translateY(0px); }
  to { opacity: 0; transform: translateY(-30px); }
`;
const slideOutRight = keyframes `
  from { transform: translateX(0px); }
  to { transform: translateX(100%); }
`;
const zoomOut = keyframes `
  from { opacity: 1; transform: scale(1); }
  to { opacity: 0; transform: scale(1.05); }
`;
const animations = {
    fadeIn,
    fadeInRight,
    fadeInDown,
    fadeInLeft,
    fadeInTop,
    slideInRight,
    zoomIn,
    fadeOut,
    fadeOutRight,
    fadeOutDown,
    fadeOutLeft,
    fadeOutTop,
    slideOutRight,
    zoomOut,
};
export const animation = ({ $animationName, $animationDuration, }) => $animationName
    ? css `
        animation: ${animations[$animationName]} ${$animationDuration}ms linear
          both;
      `
    : '';
